import lodashInvert from 'lodash/fp/invert';

export const HOUSEHOLD_STATUS_ACTIVE = 'Active';
export const HOUSEHOLD_STATUS_ARCHIVED = 'Archived';
export const HOUSEHOLD_STATUS_MOVED_IN = 'MovedIn';

export const HOUSEHOLD_ARCHIVE_REASON_FOUND_PLACE_ON_THEIR_OWN = 'FoundPlaceOnTheirOwn';
export const HOUSEHOLD_ARCHIVE_REASON_NO_RESPONSE = 'NoResponse';
export const HOUSEHOLD_ARCHIVE_REASON_INACTIVE = 'Inactive';
export const HOUSEHOLD_ARCHIVE_REASON_OTHER = 'Other';

export const HOUSEHOLD_APPLICATION_STATUS_REQUESTED = 'Requested';
export const HOUSEHOLD_APPLICATION_STATUS_STARTED = 'Started';
export const HOUSEHOLD_APPLICATION_STATUS_COMPLETED = 'Completed';
export const HOUSEHOLD_APPLICATION_STATUS_PAID = 'Paid';
export const HOUSEHOLD_APPLICATION_STATUS_INCOME_VERIFIED = 'IncomeVerified'; // Sunroom listings - Guarantors
export const HOUSEHOLD_APPLICATION_STATUS_PENDING_DOCUMENTS = 'PendingDocuments'; // Sunroom listings
export const HOUSEHOLD_APPLICATION_STATUS_REVIEWING_DOCUMENTS = 'ReviewingDocuments'; // Sunroom listings
export const HOUSEHOLD_APPLICATION_STATUS_PENDING_VERIFICATION = 'PendingVerification'; // Sunroom listings
export const HOUSEHOLD_APPLICATION_STATUS_PENDING_TRANSUNION = 'PendingTransunion'; // Sunroom listings
export const HOUSEHOLD_APPLICATION_STATUS_DELIVERED = 'Delivered';
export const HOUSEHOLD_APPLICATION_STATUS_PENDING_LANDLORD = 'PendingLandlord'; // Sunroom listings
export const HOUSEHOLD_APPLICATION_STATUS_ACCEPTED = 'Accepted';
export const HOUSEHOLD_APPLICATION_STATUS_DEPOSIT_PAID = 'DepositPaid'; // Sunroom listings
export const HOUSEHOLD_APPLICATION_STATUS_LEASE_DRAFT_PENDING = 'LeaseDraftPending'; // Sunroom listings
export const HOUSEHOLD_APPLICATION_STATUS_LEASE_SENT = 'LeaseSent'; // Sunroom listings
export const HOUSEHOLD_APPLICATION_STATUS_LEASE_SIGNED = 'LeaseSigned';

export const HOUSEHOLD_APPLICATION_VERIFICATION_OF_RENTAL_PDF = 'https://s3.amazonaws.com/sr-file-uploads-prod/renter-application-pdfs/VOR.pdf'; // eslint-disable-line max-len

export const HOUSEHOLD_APPLICATION_EMPLOYMENT_STATUS_RECENTLY_EMPLOYED = 'recentlyEmployed';
export const HOUSEHOLD_APPLICATION_EMPLOYMENT_STATUS_EMPLOYED = 'employed';
export const HOUSEHOLD_APPLICATION_EMPLOYMENT_STATUS_NOT_EMPLOYED = 'notEmployed';

export const HOUSEHOLD_APPLICATION_STATUS_GROUP_SR = 'HOUSEHOLD_APPLICATION_STATUS_GROUP_SR';
export const HOUSEHOLD_APPLICATION_STATUS_GROUP_GUARANTOR = 'HOUSEHOLD_APPLICATION_STATUS_GROUP_GUARANTOR';
export const HOUSEHOLD_APPLICATION_STATUS_GROUP_DEFAULT = 'HOUSEHOLD_APPLICATION_STATUS_GROUP_DEFAULT';

export const HOUSEHOLD_APPLICATION_STATUS_GROUPS = [
  HOUSEHOLD_APPLICATION_STATUS_GROUP_DEFAULT,
  HOUSEHOLD_APPLICATION_STATUS_GROUP_SR,
  HOUSEHOLD_APPLICATION_STATUS_GROUP_GUARANTOR,
];

export const HOUSEHOLD_APPLICATION_STATUS_LIST_TO_GROUP_MAPPING = {
  [HOUSEHOLD_APPLICATION_STATUS_GROUP_DEFAULT]: [
    HOUSEHOLD_APPLICATION_STATUS_REQUESTED,
    HOUSEHOLD_APPLICATION_STATUS_STARTED,
    HOUSEHOLD_APPLICATION_STATUS_COMPLETED,
    HOUSEHOLD_APPLICATION_STATUS_PAID,
    HOUSEHOLD_APPLICATION_STATUS_DELIVERED,
    HOUSEHOLD_APPLICATION_STATUS_ACCEPTED,
    HOUSEHOLD_APPLICATION_STATUS_LEASE_SIGNED,
  ],
  [HOUSEHOLD_APPLICATION_STATUS_GROUP_SR]: [
    HOUSEHOLD_APPLICATION_STATUS_REQUESTED,
    HOUSEHOLD_APPLICATION_STATUS_STARTED,
    HOUSEHOLD_APPLICATION_STATUS_COMPLETED,
    HOUSEHOLD_APPLICATION_STATUS_PAID,
    HOUSEHOLD_APPLICATION_STATUS_PENDING_DOCUMENTS,
    HOUSEHOLD_APPLICATION_STATUS_REVIEWING_DOCUMENTS,
    HOUSEHOLD_APPLICATION_STATUS_PENDING_VERIFICATION,
    HOUSEHOLD_APPLICATION_STATUS_PENDING_TRANSUNION,
    HOUSEHOLD_APPLICATION_STATUS_PENDING_LANDLORD,
    HOUSEHOLD_APPLICATION_STATUS_ACCEPTED,
    HOUSEHOLD_APPLICATION_STATUS_DEPOSIT_PAID,
    HOUSEHOLD_APPLICATION_STATUS_LEASE_DRAFT_PENDING,
    HOUSEHOLD_APPLICATION_STATUS_LEASE_SENT,
    HOUSEHOLD_APPLICATION_STATUS_LEASE_SIGNED,
  ],
  [HOUSEHOLD_APPLICATION_STATUS_GROUP_GUARANTOR]: [
    HOUSEHOLD_APPLICATION_STATUS_REQUESTED,
    HOUSEHOLD_APPLICATION_STATUS_STARTED,
    HOUSEHOLD_APPLICATION_STATUS_COMPLETED,
    HOUSEHOLD_APPLICATION_STATUS_PAID,
    HOUSEHOLD_APPLICATION_STATUS_INCOME_VERIFIED,
  ],
};

export const HOUSEHOLD_APPLICATION_STATUS_LIST = [
  HOUSEHOLD_APPLICATION_STATUS_REQUESTED,
  HOUSEHOLD_APPLICATION_STATUS_STARTED,
  HOUSEHOLD_APPLICATION_STATUS_COMPLETED,
  HOUSEHOLD_APPLICATION_STATUS_PAID,
  HOUSEHOLD_APPLICATION_STATUS_INCOME_VERIFIED,
  HOUSEHOLD_APPLICATION_STATUS_PENDING_DOCUMENTS,
  HOUSEHOLD_APPLICATION_STATUS_REVIEWING_DOCUMENTS,
  HOUSEHOLD_APPLICATION_STATUS_PENDING_VERIFICATION,
  HOUSEHOLD_APPLICATION_STATUS_PENDING_TRANSUNION,
  HOUSEHOLD_APPLICATION_STATUS_DELIVERED,
  HOUSEHOLD_APPLICATION_STATUS_PENDING_LANDLORD,
  HOUSEHOLD_APPLICATION_STATUS_ACCEPTED,
  HOUSEHOLD_APPLICATION_STATUS_DEPOSIT_PAID,
  HOUSEHOLD_APPLICATION_STATUS_LEASE_DRAFT_PENDING,
  HOUSEHOLD_APPLICATION_STATUS_LEASE_SENT,
  HOUSEHOLD_APPLICATION_STATUS_LEASE_SIGNED,
];

export const HOUSEHOLD_APPLICATION_STATUS_PARENT_GROUP = [
  HOUSEHOLD_APPLICATION_STATUS_REQUESTED,
  HOUSEHOLD_APPLICATION_STATUS_STARTED,
  HOUSEHOLD_APPLICATION_STATUS_COMPLETED,
  HOUSEHOLD_APPLICATION_STATUS_PAID,
  HOUSEHOLD_APPLICATION_STATUS_DELIVERED,
  HOUSEHOLD_APPLICATION_STATUS_ACCEPTED,
  HOUSEHOLD_APPLICATION_STATUS_LEASE_SIGNED,
];

export const HOUSEHOLD_APPLICATION_STATUS_PARENT_GROUP_TO_CHILDREN_MAPPING = {
  [HOUSEHOLD_APPLICATION_STATUS_REQUESTED]: [
    HOUSEHOLD_APPLICATION_STATUS_REQUESTED,
  ],
  [HOUSEHOLD_APPLICATION_STATUS_STARTED]: [
    HOUSEHOLD_APPLICATION_STATUS_STARTED,
  ],
  [HOUSEHOLD_APPLICATION_STATUS_COMPLETED]: [
    HOUSEHOLD_APPLICATION_STATUS_COMPLETED,
  ],
  [HOUSEHOLD_APPLICATION_STATUS_PAID]: [
    HOUSEHOLD_APPLICATION_STATUS_PAID,
    HOUSEHOLD_APPLICATION_STATUS_INCOME_VERIFIED,
    HOUSEHOLD_APPLICATION_STATUS_PENDING_DOCUMENTS,
    HOUSEHOLD_APPLICATION_STATUS_REVIEWING_DOCUMENTS,
    HOUSEHOLD_APPLICATION_STATUS_PENDING_VERIFICATION,
    HOUSEHOLD_APPLICATION_STATUS_PENDING_TRANSUNION,
  ],
  [HOUSEHOLD_APPLICATION_STATUS_DELIVERED]: [
    HOUSEHOLD_APPLICATION_STATUS_DELIVERED,
    HOUSEHOLD_APPLICATION_STATUS_PENDING_LANDLORD,
  ],
  [HOUSEHOLD_APPLICATION_STATUS_ACCEPTED]: [
    HOUSEHOLD_APPLICATION_STATUS_ACCEPTED,
    HOUSEHOLD_APPLICATION_STATUS_DEPOSIT_PAID,
    HOUSEHOLD_APPLICATION_STATUS_LEASE_DRAFT_PENDING,
    HOUSEHOLD_APPLICATION_STATUS_LEASE_SENT,
  ],
  [HOUSEHOLD_APPLICATION_STATUS_LEASE_SIGNED]: [
    HOUSEHOLD_APPLICATION_STATUS_LEASE_SIGNED,
  ],
};

export const HOUSEHOLD_APPLICATION_STATUS_TO_PARTNER_FUNNEL_STEP_STATUS_MAPPING = {
  [HOUSEHOLD_APPLICATION_STATUS_REQUESTED]: HOUSEHOLD_APPLICATION_STATUS_REQUESTED,
  [HOUSEHOLD_APPLICATION_STATUS_STARTED]: HOUSEHOLD_APPLICATION_STATUS_REQUESTED,
  [HOUSEHOLD_APPLICATION_STATUS_COMPLETED]: HOUSEHOLD_APPLICATION_STATUS_COMPLETED,
  [HOUSEHOLD_APPLICATION_STATUS_PAID]: HOUSEHOLD_APPLICATION_STATUS_COMPLETED,
  [HOUSEHOLD_APPLICATION_STATUS_PENDING_DOCUMENTS]: HOUSEHOLD_APPLICATION_STATUS_COMPLETED,
  [HOUSEHOLD_APPLICATION_STATUS_REVIEWING_DOCUMENTS]: HOUSEHOLD_APPLICATION_STATUS_COMPLETED,
  [HOUSEHOLD_APPLICATION_STATUS_PENDING_VERIFICATION]: HOUSEHOLD_APPLICATION_STATUS_COMPLETED,
  [HOUSEHOLD_APPLICATION_STATUS_PENDING_TRANSUNION]: HOUSEHOLD_APPLICATION_STATUS_COMPLETED,
  [HOUSEHOLD_APPLICATION_STATUS_DELIVERED]: HOUSEHOLD_APPLICATION_STATUS_DELIVERED,
  [HOUSEHOLD_APPLICATION_STATUS_PENDING_LANDLORD]: HOUSEHOLD_APPLICATION_STATUS_DELIVERED,
  [HOUSEHOLD_APPLICATION_STATUS_ACCEPTED]: HOUSEHOLD_APPLICATION_STATUS_ACCEPTED,
  [HOUSEHOLD_APPLICATION_STATUS_DEPOSIT_PAID]: HOUSEHOLD_APPLICATION_STATUS_ACCEPTED,
  [HOUSEHOLD_APPLICATION_STATUS_LEASE_DRAFT_PENDING]: HOUSEHOLD_APPLICATION_STATUS_ACCEPTED,
  [HOUSEHOLD_APPLICATION_STATUS_LEASE_SENT]: HOUSEHOLD_APPLICATION_STATUS_ACCEPTED,
  [HOUSEHOLD_APPLICATION_STATUS_LEASE_SIGNED]: HOUSEHOLD_APPLICATION_STATUS_LEASE_SIGNED,
};

export const HOUSEHOLD_APPLICATION_STATUS_CHILDREN_GROUP_TO_PARENT_MAPPING = Object
  .keys(HOUSEHOLD_APPLICATION_STATUS_PARENT_GROUP_TO_CHILDREN_MAPPING)
  .reduce((memo, householdApplicatonStatus) => {
    HOUSEHOLD_APPLICATION_STATUS_PARENT_GROUP_TO_CHILDREN_MAPPING[householdApplicatonStatus]
      .forEach((_householdApplicatonStatus) => {
        memo[_householdApplicatonStatus] = householdApplicatonStatus;
      });
    return memo;
  }, {});

export const HOUSEHOLD_APPLICATION_STATUS_COLUMNS = HOUSEHOLD_APPLICATION_STATUS_PARENT_GROUP
  .map((householdApplicationStatus, householdApplicationStatusIndex) => {
    const includeHouseholdApplicationStatusList = HOUSEHOLD_APPLICATION_STATUS_PARENT_GROUP_TO_CHILDREN_MAPPING[// eslint-disable-line max-len
      householdApplicationStatus
    ];

    const excludeHouseholdApplicationStatusList = HOUSEHOLD_APPLICATION_STATUS_PARENT_GROUP.filter((a, i) => {
      return householdApplicationStatusIndex < i;
    }).reduce((memo, applicationStatusGroup) => {
      return [
        ...memo,
        ...HOUSEHOLD_APPLICATION_STATUS_PARENT_GROUP_TO_CHILDREN_MAPPING[applicationStatusGroup],
      ];
    }, []);

    return {
      householdApplicationStatus,
      excludeHouseholdApplicationStatusList,
      includeHouseholdApplicationStatusList,
    };
  });

export const HOUSEHOLD_APPLICATION_ARCHIVE_REASON_NO_RESPONSE = 'NoResponse';
export const HOUSEHOLD_APPLICATION_ARCHIVE_REASON_REJECTED = 'Rejected';
export const HOUSEHOLD_APPLICATION_ARCHIVE_REASON_REJECTED_BY_PARTNER = 'RejectedByPartner';
export const HOUSEHOLD_APPLICATION_ARCHIVE_REASON_NOT_INTERESTED = 'NotInterested';
export const HOUSEHOLD_APPLICATION_ARCHIVE_REASON_OTHER = 'Other';
export const HOUSEHOLD_APPLICATION_ARCHIVE_REASON_LEASED = 'Leased';
export const HOUSEHOLD_APPLICATION_ARCHIVE_REASON_ACCEPTED_ANOTHER_LISTING = 'AcceptedAnotherListing';
// Archived by machine: User did no progress application from Requested to Started after auto text drip
export const HOUSEHOLD_APPLICATION_ARCHIVE_REASON_NO_PROGRESS_REQUESTED = 'NoProgressOnApplicationAfterWTAAutoText'; // eslint-disable-line max-len
// Archived by machine: User did no progress application from Started to Complete after auto text drip
export const HOUSEHOLD_APPLICATION_ARCHIVE_REASON_NO_PROGRESS_STARTED = 'NoProgressOnApplicationAfterStartedAutoText'; // eslint-disable-line max-len
export const HOUSEHOLD_APPLICATION_ARCHIVE_REASON_HOUSEHOLD_ARCHIVED = 'HouseholdIsArchived';

export const HOUSEHOLD_APPLICATION_ARCHIVED_REASON_TO_LABEL_MAPPING = {
  [HOUSEHOLD_APPLICATION_ARCHIVE_REASON_NO_RESPONSE]: 'The renter stopped responding',
  [HOUSEHOLD_APPLICATION_ARCHIVE_REASON_REJECTED]: 'The application was rejected',
  [HOUSEHOLD_APPLICATION_ARCHIVE_REASON_REJECTED_BY_PARTNER]: 'The partner denied this application',
  [HOUSEHOLD_APPLICATION_ARCHIVE_REASON_NOT_INTERESTED]: 'Renter is no longer interested in leasing this property', // eslint-disable-line max-len
  [HOUSEHOLD_APPLICATION_ARCHIVE_REASON_OTHER]: 'The renter stopped responding',
  [HOUSEHOLD_APPLICATION_ARCHIVE_REASON_LEASED]: 'This property was leased to another renter',
  [HOUSEHOLD_APPLICATION_ARCHIVE_REASON_ACCEPTED_ANOTHER_LISTING]: 'The renter rented another property',
  [HOUSEHOLD_APPLICATION_ARCHIVE_REASON_NO_PROGRESS_REQUESTED]: '',
  [HOUSEHOLD_APPLICATION_ARCHIVE_REASON_NO_PROGRESS_STARTED]: '',
  [HOUSEHOLD_APPLICATION_ARCHIVE_REASON_HOUSEHOLD_ARCHIVED]: 'Application is archived',
};

export const HOUSEHOLD_LISTING_STATUS_ACTIVE = 'Active';
export const HOUSEHOLD_LISTING_STATUS_ARCHIVED = 'Archived';

export const HOUSEHOLD_USER_REMOVAL_REASON_FOUND_ANOTHER_PLACE = 'FoundAnotherPlace';
export const HOUSEHOLD_USER_REMOVAL_REASON_LOW_INCOME = 'LowIncome';
export const HOUSEHOLD_USER_REMOVAL_REASON_BAD_CREDIT = 'BadCredit';
export const HOUSEHOLD_USER_REMOVAL_REASON_PERSONAL_REASON = 'PersonalReason';
export const HOUSEHOLD_USER_REMOVAL_REASON_OTHER = 'Other';

export const HOUSEHOLD_APPLICATION_CATEGORY_RENTER_PROFILE = 'renterProfile';
export const HOUSEHOLD_APPLICATION_CATEGORY_HOUSEHOLD_APPLICATION = 'listingApplication';
export const HOUSEHOLD_APPLICATION_CATEGORY_GUARANTOR_APPLICATION = 'guarantorApplication';

export const HOUSEHOLD_APPLICATION_CATEGORY_TO_LABEL_MAPPING = {
  [HOUSEHOLD_APPLICATION_CATEGORY_RENTER_PROFILE]: 'Renter Profile',
  [HOUSEHOLD_APPLICATION_CATEGORY_HOUSEHOLD_APPLICATION]: 'Listing Application',
  [HOUSEHOLD_APPLICATION_CATEGORY_GUARANTOR_APPLICATION]: 'Guarantor Application',
};

export const HOUSEHOLD_REJECTED_REASON_BAD_CREDIT = 'BadCredit';
export const HOUSEHOLD_REJECTED_REASON_COMPETING_APPLICATION = 'CompetingApplication';
export const HOUSEHOLD_REJECTED_REASON_DISCRIMINATION = 'Discrimination';
export const HOUSEHOLD_REJECTED_REASON_INCOME = 'Income';
export const HOUSEHOLD_REJECTED_REASON_INCORRECT_MLS_STATUS = 'IncorrectMlsStatus';
export const HOUSEHOLD_REJECTED_REASON_LISTING_WITHDRAWN = 'ListingWithdrawn';
export const HOUSEHOLD_REJECTED_REASON_MOVE_DATE_FAR_AWAY = 'MoveDateTooFarAway';
export const HOUSEHOLD_REJECTED_REASON_ROOMMATES = 'Roommates';
export const HOUSEHOLD_REJECTED_REASON_PETS = 'Pets';
export const HOUSEHOLD_REJECTED_REASON_UNSATISFACTORY_BACKGROUND = 'UnsatisfactoryBackground';
export const HOUSEHOLD_REJECTED_REASON_UNSATISFACTORY_RENTAL_HISTORY = 'UnsatisfactoryRentalHistory';

export const HOUSEHOLD_LISTING_ARCHIVED_REASON_DENIED = 'Denied';
export const HOUSEHOLD_LISTING_ARCHIVED_REASON_LEASE_ANOTHER_PROPERTY = 'LeaseAnotherProperty';
export const HOUSEHOLD_LISTING_ARCHIVED_REASON_RENTER_STOPPED_RESPONDING = 'RenterStoppedResponding';
export const HOUSEHOLD_LISTING_ARCHIVED_REASON_OTHER = 'Other';

export const HOUSEHOLD_LISTING_ARCHIVE_REASON_OPTION_ITEMS = [
  {
    label: 'Denied',
    value: HOUSEHOLD_LISTING_ARCHIVED_REASON_DENIED,
  },
  {
    label: 'Leased another property',
    value: HOUSEHOLD_LISTING_ARCHIVED_REASON_LEASE_ANOTHER_PROPERTY,
  },
  {
    label: 'Renter stopped responding',
    value: HOUSEHOLD_LISTING_ARCHIVED_REASON_RENTER_STOPPED_RESPONDING,
  },
  {
    label: 'Other',
    value: HOUSEHOLD_LISTING_ARCHIVED_REASON_OTHER,
  },
];

export const HOUSEHOLD_REJECTED_REASON_OPTION_ITEMS = [
  {
    label: 'Credit score does not meet requirements',
    value: HOUSEHOLD_REJECTED_REASON_BAD_CREDIT,
  },
  {
    label: 'Competing application',
    value: HOUSEHOLD_REJECTED_REASON_COMPETING_APPLICATION,
  },
  {
    label: 'Discrimination',
    value: HOUSEHOLD_REJECTED_REASON_DISCRIMINATION,
  },
  {
    label: 'Household income does not meet requirements',
    value: HOUSEHOLD_REJECTED_REASON_INCOME,
  },
  {
    label: 'Incorrect MLS Status',
    value: HOUSEHOLD_REJECTED_REASON_INCORRECT_MLS_STATUS,
  },
  {
    label: 'The property was taken off the market',
    value: HOUSEHOLD_REJECTED_REASON_LISTING_WITHDRAWN,
  },
  {
    label: 'Renter’s move date was too far out',
    value: HOUSEHOLD_REJECTED_REASON_MOVE_DATE_FAR_AWAY,
  },
  {
    label: 'Roommates did not complete application',
    value: HOUSEHOLD_REJECTED_REASON_ROOMMATES,
  },
  {
    label: 'Household had too many pets and/or aggressive breeds',
    value: HOUSEHOLD_REJECTED_REASON_PETS,
  },
  {
    label: 'Applicant’s background check did not meet requirements',
    value: HOUSEHOLD_REJECTED_REASON_UNSATISFACTORY_BACKGROUND,
  },
  {
    label: 'Applicant’s rental history did not meet requirements',
    value: HOUSEHOLD_REJECTED_REASON_UNSATISFACTORY_RENTAL_HISTORY,
  },
];

export const HOUSEHOLD_USER_REMOVAL_REASON_OPTION_ITEMS = [
  {
    label: 'Found Another Place',
    value: HOUSEHOLD_USER_REMOVAL_REASON_FOUND_ANOTHER_PLACE,
  },
  {
    label: 'Low Income',
    value: HOUSEHOLD_USER_REMOVAL_REASON_LOW_INCOME,
  },
  {
    label: 'Bad Credit',
    value: HOUSEHOLD_USER_REMOVAL_REASON_BAD_CREDIT,
  },
  {
    label: 'Personal Reasons',
    value: HOUSEHOLD_USER_REMOVAL_REASON_PERSONAL_REASON,
  },
  {
    label: 'Other',
    value: HOUSEHOLD_USER_REMOVAL_REASON_OTHER,
  },
];

export const HOUSEHOLD_APPLICATION_STATUS_TO_LABEL_MAPPING = {
  [HOUSEHOLD_APPLICATION_STATUS_REQUESTED]: 'Wants To Apply',
  [HOUSEHOLD_APPLICATION_STATUS_STARTED]: 'Started App',
  [HOUSEHOLD_APPLICATION_STATUS_COMPLETED]: 'Completed App',
  [HOUSEHOLD_APPLICATION_STATUS_PAID]: 'App Paid',
  [HOUSEHOLD_APPLICATION_STATUS_INCOME_VERIFIED]: 'Income Verified',
  [HOUSEHOLD_APPLICATION_STATUS_PENDING_DOCUMENTS]: 'Pending Documents',

  [HOUSEHOLD_APPLICATION_STATUS_REVIEWING_DOCUMENTS]: 'Reviewing Documents',
  [HOUSEHOLD_APPLICATION_STATUS_PENDING_VERIFICATION]: 'Pending Go4Rent',
  [HOUSEHOLD_APPLICATION_STATUS_PENDING_TRANSUNION]: 'Pending Transunion',
  [HOUSEHOLD_APPLICATION_STATUS_PENDING_LANDLORD]: 'Pending Landlord',
  [HOUSEHOLD_APPLICATION_STATUS_DELIVERED]: 'App Delivered',
  [HOUSEHOLD_APPLICATION_STATUS_ACCEPTED]: 'App Accepted',

  [HOUSEHOLD_APPLICATION_STATUS_DEPOSIT_PAID]: 'Deposit Paid',
  [HOUSEHOLD_APPLICATION_STATUS_LEASE_DRAFT_PENDING]: 'Lease Draft Pending',
  [HOUSEHOLD_APPLICATION_STATUS_LEASE_SENT]: 'Lease Sent',
  [HOUSEHOLD_APPLICATION_STATUS_LEASE_SIGNED]: 'Lease Signed',
};

export const HOUSEHOLD_APPLICATION_STATUS_OPTION_ITEMS = [
  {
    label: HOUSEHOLD_APPLICATION_STATUS_TO_LABEL_MAPPING[HOUSEHOLD_APPLICATION_STATUS_REQUESTED],
    value: HOUSEHOLD_APPLICATION_STATUS_REQUESTED,
  },
  {
    label: HOUSEHOLD_APPLICATION_STATUS_TO_LABEL_MAPPING[HOUSEHOLD_APPLICATION_STATUS_STARTED],
    value: HOUSEHOLD_APPLICATION_STATUS_STARTED,
  },
  {
    label: HOUSEHOLD_APPLICATION_STATUS_TO_LABEL_MAPPING[HOUSEHOLD_APPLICATION_STATUS_COMPLETED],
    value: HOUSEHOLD_APPLICATION_STATUS_COMPLETED,
  },
  {
    label: HOUSEHOLD_APPLICATION_STATUS_TO_LABEL_MAPPING[HOUSEHOLD_APPLICATION_STATUS_PAID],
    value: HOUSEHOLD_APPLICATION_STATUS_PAID,
  },
  {
    label: HOUSEHOLD_APPLICATION_STATUS_TO_LABEL_MAPPING[HOUSEHOLD_APPLICATION_STATUS_INCOME_VERIFIED],
    value: HOUSEHOLD_APPLICATION_STATUS_INCOME_VERIFIED,
  },
  {
    label: HOUSEHOLD_APPLICATION_STATUS_TO_LABEL_MAPPING[HOUSEHOLD_APPLICATION_STATUS_PENDING_DOCUMENTS],
    value: HOUSEHOLD_APPLICATION_STATUS_PENDING_DOCUMENTS,
  },
  {
    label: HOUSEHOLD_APPLICATION_STATUS_TO_LABEL_MAPPING[HOUSEHOLD_APPLICATION_STATUS_REVIEWING_DOCUMENTS],
    value: HOUSEHOLD_APPLICATION_STATUS_REVIEWING_DOCUMENTS,
  },
  {
    label: HOUSEHOLD_APPLICATION_STATUS_TO_LABEL_MAPPING[HOUSEHOLD_APPLICATION_STATUS_PENDING_VERIFICATION],
    value: HOUSEHOLD_APPLICATION_STATUS_PENDING_VERIFICATION,
  },
  {
    label: HOUSEHOLD_APPLICATION_STATUS_TO_LABEL_MAPPING[HOUSEHOLD_APPLICATION_STATUS_PENDING_TRANSUNION],
    value: HOUSEHOLD_APPLICATION_STATUS_PENDING_TRANSUNION,
  },
  {
    label: HOUSEHOLD_APPLICATION_STATUS_TO_LABEL_MAPPING[HOUSEHOLD_APPLICATION_STATUS_PENDING_LANDLORD],
    value: HOUSEHOLD_APPLICATION_STATUS_PENDING_LANDLORD,
  },
  {
    label: HOUSEHOLD_APPLICATION_STATUS_TO_LABEL_MAPPING[HOUSEHOLD_APPLICATION_STATUS_DELIVERED],
    value: HOUSEHOLD_APPLICATION_STATUS_DELIVERED,
  },
  {
    label: HOUSEHOLD_APPLICATION_STATUS_TO_LABEL_MAPPING[HOUSEHOLD_APPLICATION_STATUS_ACCEPTED],
    value: HOUSEHOLD_APPLICATION_STATUS_ACCEPTED,
  },
  {
    label: HOUSEHOLD_APPLICATION_STATUS_TO_LABEL_MAPPING[HOUSEHOLD_APPLICATION_STATUS_DEPOSIT_PAID],
    value: HOUSEHOLD_APPLICATION_STATUS_DEPOSIT_PAID,
  },
  {
    label: HOUSEHOLD_APPLICATION_STATUS_TO_LABEL_MAPPING[HOUSEHOLD_APPLICATION_STATUS_LEASE_DRAFT_PENDING],
    value: HOUSEHOLD_APPLICATION_STATUS_LEASE_DRAFT_PENDING,
  },
  {
    label: HOUSEHOLD_APPLICATION_STATUS_TO_LABEL_MAPPING[HOUSEHOLD_APPLICATION_STATUS_LEASE_SENT],
    value: HOUSEHOLD_APPLICATION_STATUS_LEASE_SENT,
  },
  {
    label: HOUSEHOLD_APPLICATION_STATUS_TO_LABEL_MAPPING[HOUSEHOLD_APPLICATION_STATUS_LEASE_SIGNED],
    value: HOUSEHOLD_APPLICATION_STATUS_LEASE_SIGNED,
  },
];

export const HOUSEHOLD_APPLICATION_STATUS_OPTION_ITEMS_TO_GROUP_MAPPING = (
  HOUSEHOLD_APPLICATION_STATUS_GROUPS.reduce((memo, householdListingApplicationType) => {
    const householdListingApplicationStatusList = HOUSEHOLD_APPLICATION_STATUS_LIST_TO_GROUP_MAPPING[householdListingApplicationType]; // eslint-disable-line max-len
    return {
      ...memo,
      [householdListingApplicationType]: HOUSEHOLD_APPLICATION_STATUS_OPTION_ITEMS
        .filter((option) => householdListingApplicationStatusList.includes(option.value)),
    };
  }, [])
);

export const HOUSEHOLD_APPLICATION_GUARANTOR_STATUS_OPTION_ITEMS = HOUSEHOLD_APPLICATION_STATUS_OPTION_ITEMS_TO_GROUP_MAPPING[// eslint-disable-line max-len
  HOUSEHOLD_APPLICATION_STATUS_GROUP_GUARANTOR
];

export const householdApplicationStatusesToFollowUp = [
  HOUSEHOLD_APPLICATION_STATUS_REQUESTED,
  HOUSEHOLD_APPLICATION_STATUS_STARTED,
  HOUSEHOLD_APPLICATION_STATUS_COMPLETED,
  HOUSEHOLD_APPLICATION_STATUS_PAID,
  HOUSEHOLD_APPLICATION_STATUS_DELIVERED,
  HOUSEHOLD_APPLICATION_STATUS_ACCEPTED,
];

export const HOUSEHOLD_APPLICATION_STATUS_DELIVERED_OR_FURTHER = [
  HOUSEHOLD_APPLICATION_STATUS_PENDING_LANDLORD,
  HOUSEHOLD_APPLICATION_STATUS_ACCEPTED,
  HOUSEHOLD_APPLICATION_STATUS_DEPOSIT_PAID,
  HOUSEHOLD_APPLICATION_STATUS_LEASE_DRAFT_PENDING,
  HOUSEHOLD_APPLICATION_STATUS_LEASE_SENT,
  HOUSEHOLD_APPLICATION_STATUS_LEASE_SIGNED,
];

export const HOUSEHOLD_APPLICATION_STATUS_LIST_NOT_COMPLETED = [
  HOUSEHOLD_APPLICATION_STATUS_REQUESTED,
  HOUSEHOLD_APPLICATION_STATUS_STARTED,
];

export const HOUSEHOLD_APPLICATION_STATUS_LIST_ACCEPTED = [
  HOUSEHOLD_APPLICATION_STATUS_ACCEPTED,
  HOUSEHOLD_APPLICATION_STATUS_DEPOSIT_PAID,
  HOUSEHOLD_APPLICATION_STATUS_LEASE_DRAFT_PENDING,
  HOUSEHOLD_APPLICATION_STATUS_LEASE_SENT,
  HOUSEHOLD_APPLICATION_STATUS_LEASE_SIGNED,
];

export const HOUSEHOLD_APPLICATION_STATUS_LIST_TO_LISTING_STATUS_PENDING = [
  HOUSEHOLD_APPLICATION_STATUS_DEPOSIT_PAID,
  HOUSEHOLD_APPLICATION_STATUS_LEASE_DRAFT_PENDING,
  HOUSEHOLD_APPLICATION_STATUS_LEASE_SENT,
];

export const HOUSEHOLD_APPLICATION_SENT_TO_LANDLORD_STATUSES = [
  HOUSEHOLD_APPLICATION_STATUS_PENDING_LANDLORD,
  HOUSEHOLD_APPLICATION_STATUS_ACCEPTED,
  HOUSEHOLD_APPLICATION_STATUS_DEPOSIT_PAID,
  HOUSEHOLD_APPLICATION_STATUS_LEASE_DRAFT_PENDING,
  HOUSEHOLD_APPLICATION_STATUS_LEASE_SENT,
  HOUSEHOLD_APPLICATION_STATUS_LEASE_SIGNED,
];

// TODO(@d-oliveros): Move to an appropiate location when Sunroom Club stuff
// grows enough to get its own constants/helpers file.
export const SUNROOM_CLUB_MEMBERSHIP_FEE = 25;

export const PREQUAL_MINIMUN_CREDIT_SCORE_OK = 600;

export const HOUSEHOLD_APPLICATION_PET_FIELDS_LIST = [
  'name',
  'type',
  'breed',
  'weight',
  'color',
  'age',
  'gender',
  'neutered',
  'declawed',
  'rabiesShotsCurrent',
  'isEsa',
];

export const HOUSEHOLD_APPLICATION_VEHICLE_FIELDS_LIST = [
  'type',
  'model',
  'color',
  'year',
  'licensePlateNumber',
  'licenseState',
  'monthlyPayment',
];

export const HOUSEHOLD_APPLICATION_CHILDREN_FIELDS_LIST = [
  'name',
  'age',
  'relationship',
];

export const HOUSEHOLD_DOCUMENT_CATEGORY_TENANT_REP_AGREEMENT = 'tenantRepAgreement';
export const HOUSEHOLD_DOCUMENT_CATEGORY_PET_AGREEMENT = 'petAgreement';
export const HOUSEHOLD_DOCUMENT_CATEGORY_APARTMENT_LEASE_APPLICATION = 'apartmentLeaseApplication';
export const HOUSEHOLD_DOCUMENT_CATEGORY_RESIDENTIAL_LEASE_APPLICATION = 'residentialApplication';
export const HOUSEHOLD_DOCUMENT_CATEGORY_RELEASE_INFORMATION_AGREEMENT = 'releaseInformationAgreement';
export const HOUSEHOLD_DOCUMENT_CATEGORY_GUARANTOR_APPLICATION = 'guarantorApplication';

export const HOUSEHOLD_DOCUMENT_CATEGORY_LIST = [
  HOUSEHOLD_DOCUMENT_CATEGORY_TENANT_REP_AGREEMENT,
  HOUSEHOLD_DOCUMENT_CATEGORY_PET_AGREEMENT,
  HOUSEHOLD_DOCUMENT_CATEGORY_APARTMENT_LEASE_APPLICATION,
  HOUSEHOLD_DOCUMENT_CATEGORY_RESIDENTIAL_LEASE_APPLICATION,
  HOUSEHOLD_DOCUMENT_CATEGORY_RELEASE_INFORMATION_AGREEMENT,
  HOUSEHOLD_DOCUMENT_CATEGORY_GUARANTOR_APPLICATION,
];

export const HOUSEHOLD_DOCUMENT_CATEGORY_TO_ORDER_MAPPING = HOUSEHOLD_DOCUMENT_CATEGORY_LIST
  .reduce((memo, category, index) => ({
    ...[memo],
    [category]: index,
  }), {});

// Historical application webmerge constants
export const HOUSEHOLD_APPLICATION_WEBMERGE_DOCUMENT_ID_TENANT_REP_AGREEMENT = '220097';
export const HOUSEHOLD_APPLICATION_WEBMERGE_DOCUMENT_ID_PET_AGREEMENT = '220098';
export const HOUSEHOLD_APPLICATION_WEBMERGE_DOCUMENT_ID_TAA = '220096';
export const HOUSEHOLD_APPLICATION_WEBMERGE_DOCUMENT_ID_TAR = '220095';
export const HOUSEHOLD_APPLICATION_WEBMERGE_DOCUMENT_ID_RELEASE_INFORMATION_AGREEMENT = '388813';
export const HOUSEHOLD_APPLICATION_WEBMERGE_DOCUMENT_ID_GUARANTOR_TAR = '175546';

export const HOUSEHOLD_APPLICATION_WEBMERGE_APPLICATION_DOCUMENT_IDS = [
  HOUSEHOLD_APPLICATION_WEBMERGE_DOCUMENT_ID_TENANT_REP_AGREEMENT,
  HOUSEHOLD_APPLICATION_WEBMERGE_DOCUMENT_ID_PET_AGREEMENT,
  HOUSEHOLD_APPLICATION_WEBMERGE_DOCUMENT_ID_TAR,
  HOUSEHOLD_APPLICATION_WEBMERGE_DOCUMENT_ID_RELEASE_INFORMATION_AGREEMENT,
  HOUSEHOLD_APPLICATION_WEBMERGE_DOCUMENT_ID_TAA,
];

export const HOUSEHOLD_APPLICATION_WEBMERGE_APPLICATION_SUBMISSION_DOCUMENT_IDS = [
  HOUSEHOLD_APPLICATION_WEBMERGE_DOCUMENT_ID_GUARANTOR_TAR,
  HOUSEHOLD_APPLICATION_WEBMERGE_DOCUMENT_ID_RELEASE_INFORMATION_AGREEMENT,
];

export const HOUSEHOLD_APPLICATION_WEBMERGE_PDF_LINK_FIELD_NAME_TENTANT_REP_AGREEMENT = 'pdfLinkApplicationTenantRepAgreement'; // eslint-disable-line max-len
export const HOUSEHOLD_APPLICATION_WEBMERGE_PDF_LINK_FIELD_NAME_PET_AGREEMENT = 'pdfLinkApplicationPetAgreement'; // eslint-disable-line max-len
export const HOUSEHOLD_APPLICATION_WEBMERGE_PDF_LINK_FIELD_NAME_TAA = 'pdfLinkApplicationTaa';
export const HOUSEHOLD_APPLICATION_WEBMERGE_PDF_LINK_FIELD_NAME_TAR = 'pdfLinkApplicationTar';
export const HOUSEHOLD_APPLICATION_WEBMERGE_PDF_LINK_FIELD_NAME_RELEASE_INFORMATION_AGREEMENT = 'pdfLinkApplicationInformationReleaseAgreement'; // eslint-disable-line max-len
export const HOUSEHOLD_APPLICATION_WEBMERGE_PDF_LINK_FIELD_NAME_GUARANTOR_TAR = 'pdfLinkApplicationGuarantorTar'; // eslint-disable-line max-len

/* eslint-disable max-len */
export const HOUSEHOLD_APPLICATION_PDF_LINK_FIELD_NAME_TO_WEBMERGE_DOCUMENT_ID_MAPPING = {
  [HOUSEHOLD_APPLICATION_WEBMERGE_PDF_LINK_FIELD_NAME_TENTANT_REP_AGREEMENT]: HOUSEHOLD_APPLICATION_WEBMERGE_DOCUMENT_ID_TENANT_REP_AGREEMENT,
  [HOUSEHOLD_APPLICATION_WEBMERGE_PDF_LINK_FIELD_NAME_PET_AGREEMENT]: HOUSEHOLD_APPLICATION_WEBMERGE_DOCUMENT_ID_PET_AGREEMENT,
  [HOUSEHOLD_APPLICATION_WEBMERGE_PDF_LINK_FIELD_NAME_TAA]: HOUSEHOLD_APPLICATION_WEBMERGE_DOCUMENT_ID_TAA,
  [HOUSEHOLD_APPLICATION_WEBMERGE_PDF_LINK_FIELD_NAME_TAR]: HOUSEHOLD_APPLICATION_WEBMERGE_DOCUMENT_ID_TAR,
  [HOUSEHOLD_APPLICATION_WEBMERGE_PDF_LINK_FIELD_NAME_RELEASE_INFORMATION_AGREEMENT]: HOUSEHOLD_APPLICATION_WEBMERGE_DOCUMENT_ID_RELEASE_INFORMATION_AGREEMENT,
  [HOUSEHOLD_APPLICATION_WEBMERGE_PDF_LINK_FIELD_NAME_GUARANTOR_TAR]: HOUSEHOLD_APPLICATION_WEBMERGE_DOCUMENT_ID_GUARANTOR_TAR,
};

export const HOUSEHOLD_APPLICATION_WEBMERGE_DOCUMENT_ID_TO_PDF_LINK_FIELD_NAME_MAPPING = lodashInvert(
  HOUSEHOLD_APPLICATION_PDF_LINK_FIELD_NAME_TO_WEBMERGE_DOCUMENT_ID_MAPPING
);
/* eslint-enable max-len */

export const HOUSEHOLD_APPLICATION_WEBMERGE_FRIENDLY_DOCUMENT_NAMES = {
  [HOUSEHOLD_APPLICATION_WEBMERGE_PDF_LINK_FIELD_NAME_TENTANT_REP_AGREEMENT]: 'tenant-rep-agreement',
  [HOUSEHOLD_APPLICATION_WEBMERGE_PDF_LINK_FIELD_NAME_PET_AGREEMENT]: 'pet-agreement',
  [HOUSEHOLD_APPLICATION_WEBMERGE_PDF_LINK_FIELD_NAME_TAA]: 'TAA',
  [HOUSEHOLD_APPLICATION_WEBMERGE_PDF_LINK_FIELD_NAME_TAR]: 'TAR',
  [HOUSEHOLD_APPLICATION_WEBMERGE_PDF_LINK_FIELD_NAME_RELEASE_INFORMATION_AGREEMENT]: 'information-release-agreement', // eslint-disable-line max-len
  [HOUSEHOLD_APPLICATION_WEBMERGE_PDF_LINK_FIELD_NAME_GUARANTOR_TAR]: 'guarantor-tar',
};
